import React, { useContext, useEffect, useState } from "react";
import "./QuizPage.css";
import { baseUrl, dataContext, portal } from "../../App";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import BlockRound from "./BlockRound/BlockRound";
import ResultModal from "./ResultModal/ResultModal";
import mixUpImg from "./bgimage/mixUpBg.png";
import wordlyImg from "./bgimage/wordly.png";
import spellingBeeImg from "./bgimage/spellingBee.png";
import QuestionBodyBoishakh from './QuestionBodyBoishakh/QuestionBodyBoishakh';
import QuestionBodySpelling from './QuestionBodySpelling/QuestionBodySpelling';
import { apiUrl } from '../../api.config';
import { fetchUserPlayingHistory } from '../../services';
import QuestionBodyMemoryMatch from "./QuestionBodyMemoryMatch/QuestionBodyMemoryMatch";

const QuizPage = () => {
  const navigate = useNavigate();
  const { token, setToken, playerData, setPlayerData } =
    useContext(dataContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const eventId = parseInt(searchParams.get("eventId"))
  const [eventDetails, setEventDetails] = useState({})
  const [showQuestions, setShowQuestions] = useState(false)
  const [showBlockModal, setShowBlockModal] = useState(false)
  const [showResultModal, setShowResultModal] = useState(false)
  const [finalScore, setFinalScore] = useState(0)
  const [playerRound, setPlayerRound] = useState(null)
  const [isLoadingEnd, setIsLoadingEnd] = useState(false)
  const [playedRoundNumber, setPlayedRoundNumber] = useState(0)
  const [userPlayingHistoryData, setUserPlayingHistoryData] = useState([])
  const [gameDifficulty, setGameDifficulty] = useState(sessionStorage.getItem("memoryMatchDifficulty") || "beginner");


  useEffect(() => {
    if (token && eventId && playerData?.id) {
      fetchUserPlayingHistory(token)
        .then(response => {
          console.log('response of playing history', response)
          setUserPlayingHistoryData(response)
          const allEvent = [
            {
              "id": 67,
              "is_event": true,
              "event_type": "Daily",
              "events": "English",
              "round": 2,
              "status": "active",
              "question_set": "60",
              "passing_score": 60,
              "allocated_time": 180,
              "banner_url": "https://ms.purplepatch.online/bkash-quiz-banner/bpl.png",
              "company_id": 18,
              "prize1": null,
              "prize2": null,
              "prize3": null
            },
            {
              "id": 79,
              "is_event": true,
              "event_type": "Daily",
              "events": "Bangla",
              "round": 2,
              "status": "active",
              "question_set": "60",
              "passing_score": 60,
              "allocated_time": 180,
              "banner_url": "",
              "company_id": 18,
              "prize1": null,
              "prize2": null,
              "prize3": null
            },
            {
              "id": 134,
              "is_event": true,
              "event_type": "Daily",
              "events": "SpellingBee",
              "round": 2,
              "status": "active",
              "question_set": "1",
              "passing_score": 20,
              "allocated_time": 180,
              "banner_url": "https://ms.purplepatch.online/bkash-quiz-banner/bpl.png",
              "company_id": 18,
              "prize1": null,
              "prize2": null,
              "prize3": null
            },
            {
              "id": 151,
              "is_event": true,
              "event_type": "Daily",
              "events": "MemoryMatch",
              "round": 2,
              "status": "active",
              "question_set": "1",
              "passing_score": 20,
              "allocated_time": 180,
              "banner_url": "https://ms.purplepatch.online/bkash-quiz-banner/bpl.png",
              "company_id": 18,
              "prize1": null,
              "prize2": null,
              "prize3": null
            },
          ];

          if (parseInt(eventId) === 67 || parseInt(eventId) === 79) {
            if (!playerData?.isSubscribe) {
              navigate('../')
            }
          } else if (parseInt(eventId) === 134) {
            if (!playerData?.isSubscribeSpellingBee) {
              navigate('../')
            }
          } else if (parseInt(eventId) === 151) {
            if (!playerData?.isSubscribeMemoryMatch) {
              navigate('../')
            }
          } else {
            navigate('../')
          }
          let eventDe = allEvent.filter(event => {
            return (event?.id === eventId)
          })
          if (!eventDe.length) {
            navigate('../')
          } else {
            setEventDetails(eventDe[0])
            setIsLoadingEnd(true)
          }

        })
        .catch((res) => {
          localStorage.setItem("AuthToken", "");
          setPlayerData({});
          setToken(null);
          navigate("../");
        });
    } else {
      navigate("../");
    }
  }, []);

  useEffect(() => {
    if (isLoadingEnd) {
      let playerLeaderboardArr = userPlayingHistoryData?.event_history;
      console.log('playerLeaderboardArr', playerLeaderboardArr, userPlayingHistoryData)
      let playerRoundNum = 0;
      let playerRoundTotal = 0;
      let playerLeaderboard = [];

      if (playerLeaderboardArr) {
        playerLeaderboard = playerLeaderboardArr.filter((a) => {
          if (a.event_id == eventDetails.id) {
            return a;
          }
        });
      }
      playerRoundTotal = playerLeaderboard.length
        ? playerLeaderboard[0]?.round_number__max
        : 0;
      setPlayerRound(playerRoundTotal);

      let eventRound = eventDetails?.round;
      if (parseInt(eventId) === 67 || parseInt(eventId) === 79) {
        eventRound = 2;
        playerRoundTotal = userPlayingHistoryData?.round_play?.round || 0;
        setPlayedRoundNumber(playerRoundTotal);
      }

      sessionStorage.setItem("leaderEventId", eventDetails?.id);
      if(parseInt(eventId) === 151){
        setShowQuestions(true);
      }
      else if (playerRoundTotal < eventRound) {
        setShowQuestions(true);
      } else {
        playerData.msisdn === "1867125111" ||
          playerData.msisdn === "1738246580" ||
          playerData.msisdn === "1711082515"
          ? setShowQuestions(true)
          : setShowBlockModal(true);
      }
    }
  }, [isLoadingEnd]);

  useEffect(() => {
    if (parseInt(eventId) === 151) {
      const storedDifficulty = sessionStorage.getItem("memoryMatchDifficulty");
      if (storedDifficulty) {
        setGameDifficulty(storedDifficulty);
        sessionStorage.removeItem("memoryMatchDifficulty");
      }
    }
  }, [eventId]);

  let isWordly = parseInt(eventId) === 67 || parseInt(eventId) === 79;
  let isSpellingBee = parseInt(eventId) === 134;
  let isMemoryMatch = parseInt(eventId) === 151;
  let backgroundImage = wordlyImg;
  if (isSpellingBee) {
    backgroundImage = spellingBeeImg;
  }

  return (
    <div
      className="quizPageBody"
      style={{ background: `linear-gradient(45deg, black, #0083B0)` }}
    >
      <img
        src={backgroundImage}
        alt=""
        style={{
          width: "100%",
          position: "absolute",
          bottom: 0,
          left: 0,
          zIndex: -1,
        }}
      />
      {showQuestions && isSpellingBee && (
        <QuestionBodySpelling
          eventDetails={eventDetails}
          finalScore={finalScore}
          setFinalScore={setFinalScore}
          setShowResultModal={setShowResultModal}
          playerRound={playerRound}
        />
      )}
      {showQuestions && isWordly && (
        <QuestionBodyBoishakh
          eventDetails={eventDetails}
          finalScore={finalScore}
          setFinalScore={setFinalScore}
          setShowResultModal={setShowResultModal}
          playerRound={playerRound}
        />
      )}
      {isMemoryMatch && showQuestions && (
        <QuestionBodyMemoryMatch initialDifficulty={gameDifficulty} eventDetails={eventDetails} playerRound={playerRound} />
      )}
      {showBlockModal && (
        <BlockRound
          playedRoundNumber={playedRoundNumber}
          showBlockModal={showBlockModal}
          setShowBlockModal={setShowBlockModal}
        />
      )}
      {showResultModal && (
        <ResultModal
          eventDetails={eventDetails}
          showResultModal={showResultModal}
          setShowResultModal={setShowResultModal}
          finalScore={finalScore}
        />
      )}
    </div>
  );
};

export default QuizPage;
